import {defineStore} from 'pinia'

export const useGlobalSearchStore = defineStore('globalSearch', () => {

    const searchInput = ref<string | null>(null)
    const currentModule = ref<string | null>(null)
    const connected = ref<string | null>(null)

    function setCurrentModule(newModule: string | null) {
        currentModule.value = newModule
    }

    function setSearchInput(newInput: string | null) {
        searchInput.value = newInput
    }

    function connect(tableModule: string) {
        connected.value = tableModule
    }

    function disconnect() {
        connected.value = null
    }

    return {
        searchInput,
        currentModule,
        connected,
        setCurrentModule,
        setSearchInput,
        connect,
        disconnect
    }
})